import { classNames, Tag } from '@payfit/growth-platform-brand-system-v2';
import { fontHeading2 } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import React from 'react';
import { formatPrice } from '../../../../utils/formatPrice';
import { NbTagRecord, SiteLocale } from '../../../../../types/dato';

type PriceProps = {
  price?: number;
  locale: SiteLocale;
  show?: boolean;
  discount?: number;
  tag?: NbTagRecord;
};

const Price = ({ price, locale, tag }: PriceProps) => {
  return (
    <div
      className={classNames('PriceBox_Price', 'flex items-center gap-[10px]')}
    >
      <span className={classNames(fontHeading2)}>
        {!!price && formatPrice(price, locale)}
      </span>
      {tag && (
        <Tag size="small" color="green">
          {tag.title}
        </Tag>
      )}
    </div>
  );
};

export default Price;
